import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { Spinner, Tabs, Text } from '@/ui-kit'
import { useUiKit } from '@/ui-kit/providers'
import { Trans, useLingui } from '@lingui/react/macro'
import { useState } from 'react'
import { useLeaderboard } from '../api'
import { LeaderboardMobileList } from './LeaderboardMobileList'
import { LeaderboardStatsPanel } from './LeaderboardStatsPanel'
import { LeaderboardTable } from './LeaderboardTable'
import { Pagination } from './Pagination'

const PAGE_SIZE = 10

export const Leaderboard = () => {
  const { isMobile } = useUiKit()
  const { t } = useLingui()
  const [page, setPage] = useState(1)

  const { data, isFetching } = useLeaderboard({ page, limit: PAGE_SIZE })
  const { data: user } = useFetchUser(true)

  const entries = data?.leaderboard.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE) ?? []
  const total = data?.leaderboard.length ?? 0
  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE))

  const isInitialLoad = isFetching && !data
  const isEmpty = !isFetching && entries.length === 0

  return (
    <div className="max-tablet:flex-col max-mobile:pt-4 max-mobile:pb-8 flex flex-1 pt-10">
      <div className="max-tablet:pb-8 max-tablet:pt-4 max-mobile:ml-0 max-mobile:w-auto max-mobile:pr-0 ml-4 flex flex-col pb-10">
        <div className="max-tablet:w-full max-tablet:pt-0 sticky top-[var(--header-height)] w-[270px]">
          <LeaderboardStatsPanel />
        </div>
      </div>
      <div className="max-mobile:px-0 grow px-5">
        <Tabs
          className="max-mobile:max-w-full h-10 max-w-max"
          tabs={[{ value: 'contributors', title: t`Top Contributors` }]}
          value="contributors"
          size="small"
        />
        <div className="mt-6">
          <div className="text-gray-80 mb-4">
            <Trans>Top contributors ranked by points earned, updated daily.</Trans>
          </div>
          {isInitialLoad ? (
            <div className="flex w-full justify-center">
              <Spinner className="mt-8" />
            </div>
          ) : isEmpty ? (
            <div className="m-auto max-w-[350px] rounded-xl bg-gray-100 p-6 text-center">
              <Text>
                <Trans>No data available yet</Trans>
              </Text>
            </div>
          ) : (
            <>
              {isMobile ? (
                <LeaderboardMobileList entries={entries} highlightUserId={user?.id.slice(0, 6)} />
              ) : (
                <LeaderboardTable entries={entries} highlightUserId={user?.id.slice(0, 6)} />
              )}
              <Pagination
                page={page}
                pageCount={pageCount}
                total={total}
                onPageChange={setPage}
                className="mt-6 mr-auto max-w-max"
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
